import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useOpenAutopilotUpgrade } from 'hooks/useOpenAutopilotUpgrade'
import { IconButtonProps } from 'blaze-ui/IconButton/Types'
import Lock2 from 'blaze-ui/icons/24/Lock2'

export const AutopilotLockUpgradeButton = (props: Partial<IconButtonProps>) => {
  const openVirtualMarketerPlansModal = useOpenAutopilotUpgrade()

  return (
    <IconButton
      onPress={openVirtualMarketerPlansModal}
      icon={Lock2}
      size="xs"
      variant="ghost"
      color="var(--selected-fill)"
      data-testid="autopilot-lock-upgrade-button"
      {...props}
    />
  )
}
